import axios from 'axios';  

const BaseUrl = axios.create({  
    baseURL: 'https://backend.mercylandgroup.com/api'  
});  

export default BaseUrl;  